import React from 'react';
import SharedTable from '../../../../components/shared/Table/SharedTable';
import StatusBadge from '../../../../components/shared/StatusBadge/StatusBadge';
import './CustomerList.css';

/**
 * Tabular list view for customers.
 */
export default function CustomerList({ customers, selectedIds, onSelect, onEdit, onDelete }) {
    const columns = [
        { 
            key: 'name', 
            label: 'Name / Firma', 
            sortable: true,
            render: (item) => (
                <div className="customer-name-cell">
                    <strong>{item.name}</strong>
                    <span className="customer-address">{item.address}</span>
                </div>
            )
        },
        { 
            key: 'customer_number', 
            label: 'Kundennummer', 
            sortable: true,
            render: (item) => item.customer_number || '—'
        },
        { 
            key: 'contact_person', 
            label: 'Ansprechpartner', 
            sortable: true,
            render: (item) => item.contact_person || '—'
        },
        { 
            key: 'contact', 
            label: 'E-Mail / Telefon', 
            sortable: false,
            render: (item) => (
                <div className="contact-info">
                    <span className="email">{item.email || '—'}</span>
                    <span className="phone">{item.phone}</span>
                </div>
            )
        },
        { 
            key: 'status', 
            label: 'Status', 
            sortable: true,
            render: (item) => <StatusBadge status={item.status} />
        }
    ];

    const generateActions = (customer) => [
        {
            icon: (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
            ),
            label: 'Bearbeiten',
            onClick: () => onEdit(customer),
            tooltip: 'Bearbeiten'
        },
        {
            icon: (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="3 6 5 6 21 6" />
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                    <line x1="10" y1="11" x2="10" y2="17" />
                    <line x1="14" y1="11" x2="14" y2="17" />
                </svg>
            ),
            label: 'Löschen',
            variant: 'delete',
            onClick: () => onDelete(customer.id),
            tooltip: 'Löschen'
        }
    ];

    return (
        <SharedTable
            data={customers}
            columns={columns}
            uniqueKeyField="id"
            onRowClick={onEdit}
            selectedIds={selectedIds}
            onSelectionChange={onSelect}
            actions={generateActions}
            emptyMessage="Keine Kunden gefunden."
        />
    );
}
